import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from '../developers/page-components/Title';
import { useOrdersContext } from '../../store/order/order-context';
import { PIIComponent } from './PIIComponent';
import { useIdentity } from '../../store/identyti/identity-context';

export const CustomerInformation: FC = () => {
	const { t } = useTranslation();
	const { identityState: { userData }} = useIdentity();
	const { orderContextState: { orderDetailsData }} = useOrdersContext();
	const { phone, email, firstName, lastName, billingAddress } = orderDetailsData;
	const isHidden = userData?.isPiiMasked;

	const informationItems = [
		{
			name: 'ORDERS.NAME',
			value: firstName && lastName ? `${firstName} ${lastName}` : null,
			type: 'name',
			isHidden,
		},
		{
			name: 'ORDERS.BILLING_ADDRESS',
			value: billingAddress?.line1 && billingAddress?.line2 && billingAddress?.city && billingAddress?.countryCode
				? `${billingAddress?.line1} ${billingAddress?.line2}, ${billingAddress?.city} ${billingAddress?.countryCode}`
				: null,
			type: 'address',
			isHidden,
		},
		{
			name: 'ORDERS.TELEPHONE',
			value: phone,
			type: 'phone',
			isHidden,
		},
		{
			name: 'ORDERS.EMAIL',
			value: email,
			type: 'email',
			isHidden,
		}
	];
	return (
		<div className="card mb-6" data-cy="customer-information-block">
			<div className="card-body">

				<Title title={t('ORDERS.CUSTOMER_INFORMATION')} additionalClass="fs-4 fw-bolder"/>

				{informationItems?.map(({ name, value, type, isHidden }): JSX.Element => (
					<div className="mt-3" key={name}>
						<div className="fs-9 text-muted fw-bold">
							{t(name)}
						</div>
						<PIIComponent
							value={value}
							isHidden={isHidden}
							type={type}
						/>
					</div>
				))}

			</div>
		</div>
	);
};
